import styled from '@emotion/styled';
import React from 'react';
import Icon from '@ant-design/icons';
import { Col, Row } from 'antd';
import { ReactComponent as CheckedSvgIcon } from '../assets/checked.svg';

const OptionItem = styled.div`
  position: relative;
  height: 100%;
  padding: 14px 16px;
  border: 1px solid #d3d7e0;
  cursor: pointer;

  &.checked {
    border-color: var(--ant-primary-color);
  }

  & > .anticon {
    position: absolute;
    right: -1px;
    bottom: -1px;
    font-size: 32px;
  }
`;

const Container = styled(Row)`
  &.vertical .ant-col {
    margin-bottom: 8px;
  }
`;

export interface CheckboxGroupOption {
  value: string | number;
  render?: React.ReactNode;
}

export interface CheckboxGroupProps {
  className?: string;
  value?: string | number;
  gutter?: number;
  options?: CheckboxGroupOption[];
  onChange?: (value: string | number) => void;
  layout?: 'horizontal' | 'vertical';
}
const StyledIcon = styled(Icon)`
  color: var(--fett-app-primary-color);
`;
const CheckboxGroup = (props: CheckboxGroupProps) => {
  const { className, value, options, gutter = 16, layout = 'horizontal', onChange } = props;

  return (
    <Container gutter={gutter} className={`${className || ''} ${layout}`}>
      {options?.map((option) => {
        const checked = option.value === value;

        return (
          <Col className="mb-4" span={layout === 'horizontal' ? 0.1 : 24} key={option.value}>
            <OptionItem
              className={checked ? 'checked' : ''}
              onClick={() => onChange && onChange(option.value)}
            >
              {option.render}
              {checked ? <StyledIcon component={CheckedSvgIcon} /> : null}
            </OptionItem>
          </Col>
        );
      })}
    </Container>
  );
};

export default CheckboxGroup;
